import { METHODS } from "../../refundConsts"
import type { RefundMethods } from "../../../../../../../records/bookingInput"

const methods = Object.values(METHODS)

// default value [] is needed to not break tests
const mapperBookingRefund = (
  refundMethods: RefundMethods = [],
): string[] => // FIXME: a method has been detected that possibly mutates the object, consider a more functional
  // approach (Ramda might help)
  // @ts-expect-error: Flow to TS migration.
  refundMethods.sort((a: string, b: string) => methods.indexOf(a) - methods.indexOf(b))

export default mapperBookingRefund
